import * as RadixDialog from '@radix-ui/react-dialog';
import { X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useShellStore } from '../model/shellStore';
import { NavMenu } from '../navMenu/NavMenu';
import { IconButton } from '@/shared/ui/IconButton';
import { BrandLogo } from '../header/BrandLogo';

/** Telefon/tablet: soldan açılan menü çekmecesi. */
export function MobileDrawer() {
  const { t } = useTranslation();
  const open = useShellStore((s) => s.drawerOpen);
  const setOpen = useShellStore((s) => s.setDrawer);
  return (
    <RadixDialog.Root open={open} onOpenChange={setOpen}>
      <RadixDialog.Portal>
        <RadixDialog.Overlay className="fixed inset-0 z-40 bg-[var(--overlay)]" />
        <RadixDialog.Content className="bg-bg-elevated fixed inset-y-0 left-0 z-50 flex w-[min(85vw,20rem)] flex-col shadow-[var(--shadow)] focus:outline-none">
          <RadixDialog.Title className="sr-only">{t('shell.menu')}</RadixDialog.Title>
          <div className="border-border flex h-14 items-center justify-between border-b px-3">
            <BrandLogo />
            <RadixDialog.Close asChild>
              <IconButton label={t('shell.tab.close')}>
                <X className="h-5 w-5" />
              </IconButton>
            </RadixDialog.Close>
          </div>
          <div className="min-h-0 flex-1">
            <NavMenu />
          </div>
        </RadixDialog.Content>
      </RadixDialog.Portal>
    </RadixDialog.Root>
  );
}
